import React, { Component } from "react";
import { connect } from "react-redux";

import GalleryComponent from "./GalleryComponent";

import { /*fetchMedias*/ fetchGallery } from "Thunks";

export class GalleryContainer extends Component {
  componentDidMount() {
    const { fetchGallery } = this.props;

    fetchGallery({ limit: 30 });
  }

  render() {
    const { medias, fetched, fetching, navCommunity } = this.props;
    return (
      <GalleryComponent
        medias={medias}
        fetching={fetching}
        fetched={fetched}
        navCommunity={navCommunity}
      />
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  medias: state.medias.all.items,
  //medias: state.ebox.gallery.items,
  fetching: state.ebox.gallery.fetching,
  fetched: state.ebox.gallery.fetched,
  navCommunity: state.auth.navCommunity
});

const mapDispatchToProps = dispatch => ({
  //fetchMedias: options => dispatch(fetchMedias(options))
  fetchGallery: options => dispatch(fetchGallery(options))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GalleryContainer);



// WEBPACK FOOTER //
// ./src/components/Community/Common/Gallery/GalleryContainer.js